import { useCallback } from 'react'
import { Modal } from 'antd'
import { isFormDataRequired } from '../../../../../lib/utils/collections'
import { nextStage, updateFormData } from '../../../../store/appeal/action-creators'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'
import { getStageCodeFromFormStages } from '../../../../lib/stage-conflict'

type SaveResultResponse =
  | { status: 'skipped'; reason: 'no-data' | 'required' }
  | { status: 'validation_failed'; reason: 'required' }
  | { status: 'submitted'; mode: 'update' | 'nextStage'; response: any }

export function useSaveResult() {
  const dispatch = useAppDispatch()
  const saveResult = useCallback(
    async (id, visibleFormData, stages, nextCardType): Promise<SaveResultResponse> => {
      if (!visibleFormData) {
        return { status: 'skipped', reason: 'no-data' }
      }

      const from_stage = nextCardType ? getStageCodeFromFormStages(stages) : undefined
      const formData = {
        appeal: { ...visibleFormData.resultObject },
        nextCardType,
        ...(from_stage ? { from_stage } : {}),
      }

      if (id === 'new' && !nextCardType) {
        const isRequiredFields = isFormDataRequired(formData.appeal, visibleFormData.resultSchema)
        if (!isRequiredFields) {
          return { status: 'skipped', reason: 'required' }
        }
      }

      if (nextCardType) {
        const isRequiredFields = isFormDataRequired(formData.appeal, visibleFormData.resultSchema)
        if (!isRequiredFields) {
          Modal.warning({
            title: 'Предупреждение',
            content: 'Заполните все обязательные поля',
          })
          return { status: 'validation_failed', reason: 'required' }
        }
        const response = await dispatch(nextStage(id, formData))
        return { status: 'submitted', mode: 'nextStage', response }
      }

      const response = await dispatch(updateFormData(id, formData))
      return { status: 'submitted', mode: 'update', response }
    },
    [dispatch],
  )

  return { saveResult }
}
